import { RouteObject } from "react-router-dom";
import { EmailTemplateLayoutDetail } from "../pages/admin/email-template-layouts/EmailTemplateLayoutDetail";
import { EmailTemplateLayoutsList } from "../pages/admin/email-template-layouts/EmailTemplateLayoutList";
import { EmailTemplateLayoutCreate } from "../pages/admin/email-template-layouts/EmailTemplateLayoutCreate";
import { EmailTemplateLayoutEdit } from "../pages/admin/email-template-layouts/EmailTemplateLayoutEdit";

export const emailTemplateLayoutsRoutes: RouteObject[] = [
  {
    id: "email-template-layouts-list",
    index: true,
    element: <EmailTemplateLayoutsList />,
  },
  {
    id: "email-template-layout-detail",
    path: ":id",
    element: <EmailTemplateLayoutDetail />,
  },
  {
    id: "email-template-layout-create",
    path: "create",
    element: <EmailTemplateLayoutCreate />,
  },
  {
    id: "email-template-layout-edit",
    path: ":id/edit",
    element: <EmailTemplateLayoutEdit />,
  },
];
